import React from 'react';

import styles from './Table.module.scss';

interface IColumnType {
  title: string;
  dataIndex: string;
  key: string;
  width?: number | string;
  render?: (val: string, record: IDataType) => React.ReactNode;
}
interface IDataType {
  [key: string]: string;
}

interface IProps {
  columns: IColumnType[];
  dataSource: IDataType[];
}

function Table(props: IProps) {
  const { columns, dataSource } = props;

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          {(columns || []).map((col) => {
            const { title, key, width } = col;

            return (
              <th key={key} style={{ width }}>
                {title}
              </th>
            );
          })}
        </tr>
      </thead>

      <tbody>
        {(dataSource || []).map((data, idx) => {
          return (
            <tr key={idx}>
              {(columns || []).map((col) => {
                const { dataIndex, key, render } = col;
                const record = data;
                const value = data[dataIndex];
                if (render) {
                  return <td key={key || dataIndex}>{render(value, record)}</td>;
                }

                return <td key={key || dataIndex}>{value}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default Table;
